module.exports = __webpack_public_path__ + "img/star.16b7ede9.svg";